var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.274,
    height: 12.279,
    viewBox: "0 0 12.274 12.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.687,1044l-.307,1.549a5,5,0,0,0-1.4.793l-1.514-.513-1.456,2.482,1.211,1.035a4.481,4.481,0,0,0,0,1.588l-1.211,1.035,1.456,2.482,1.514-.513a5.005,5.005,0,0,0,1.4.793l.307,1.549H57.6l.307-1.549a5.006,5.006,0,0,0,1.4-.793l1.514.513,1.456-2.482-1.211-1.035a4.49,4.49,0,0,0,0-1.588l1.211-1.035-1.456-2.482-1.514.513a5,5,0,0,0-1.4-.793L57.6,1044Zm1.456,3.057a3.082,3.082,0,1,1-3.075,3.082A3.078,3.078,0,0,1,56.143,1047.057Z",
    transform: "translate(-50.006 -1044)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.f2495d94.svg";
export { ForwardRef as ReactComponent };